/* PSI v115 — Fix anteprime prodotti chiari.
   Disattiva la "pulizia fondo bianco" (PSI v57b in theme.js) che elaborava le
   miniature via canvas e ne sostituiva il src con un blob: sui prodotti chiari
   il flood-fill sconfinava nel soggetto e cancellava capelli, incarnato e
   tessuti bianchi. Le anteprime mostrano ora la foto originale, identica alla
   scheda prodotto. Nessun altro comportamento del tema viene modificato. */
(function () {
  var SELECTOR = '.product-card-img-main, .product-card-img-hover';

  function skip(image) {
    if (!image || image.nodeType !== 1) return;
    image.dataset.psiWhiteChecked = '1';
    image.dataset.psiWhiteQueued = '1';
    var current = image.getAttribute('src') || '';
    if (current && current.indexOf('blob:') !== 0) image.dataset.psiOriginalSrc = current;
  }

  function skipAll(root) {
    if (!root || !root.querySelectorAll) return;
    if (root.matches && root.matches(SELECTOR)) skip(root);
    var found = root.querySelectorAll(SELECTOR);
    for (var i = 0; i < found.length; i++) skip(found[i]);
  }

  skipAll(document);

  if (window.MutationObserver) {
    /* PSI perf: osserva solo #main-content (dove vivono le card prodotto)
       invece di tutto document.documentElement, per ridurre il costo dei
       callback su pagine lunghe. Fallback a documentElement se assente. */
    var OBSERVE_ROOT = document.getElementById('main-content') || document.documentElement;

    /* Card aggiunte dopo il caricamento (filtri, paginazione, ricerca). */
    new MutationObserver(function (mutations) {
      for (var m = 0; m < mutations.length; m++) {
        var added = mutations[m].addedNodes;
        for (var n = 0; n < added.length; n++) skipAll(added[n]);
      }
    }).observe(OBSERVE_ROOT, { childList: true, subtree: true });

    /* Rete di sicurezza: se un src viene comunque sostituito da un blob,
       ripristina la foto originale. */
    new MutationObserver(function (mutations) {
      for (var m = 0; m < mutations.length; m++) {
        var target = mutations[m].target;
        if (!target.matches || !target.matches(SELECTOR)) continue;
        var current = target.getAttribute('src') || '';
        if (current.indexOf('blob:') !== 0) {
          if (current) target.dataset.psiOriginalSrc = current;
          continue;
        }
        var original = target.dataset.psiOriginalSrc;
        if (original) {
          try { URL.revokeObjectURL(current); } catch (e) {}
          target.setAttribute('src', original);
        }
      }
    }).observe(OBSERVE_ROOT, {
      subtree: true,
      attributes: true,
      attributeFilter: ['src']
    });
  }

  document.addEventListener('DOMContentLoaded', function () { skipAll(document); });
})();
